<template>
  <el-select v-model="id" @change="changeName">
    <el-option v-for="(item,index) in list" :key="index" :label="item.recContacts" :value="item.id"></el-option>
  </el-select>
</template>
<script>
export default {
  props: ['params', 'InfoList'],
  data () {
    return {
      id: null,
      list: []
    }
  },
  watch: {

    InfoList: {
      handler (val) {
        this.list = val
      },
      deep: true
    },
    params: {
      handler (val) {
        if (this.list.length > 0) {
          if (this.list.some(ele => ele.id === val.id)) {
            this.id = val.id
          }
        }
      },
      deep: true
    }
  },
  methods: {
    // 选择收货人后传值给父组件
    changeName (val) {
      // 由于发起备货,备货信息中收货人需要编辑当前行,所以前端需要传item
      const obj = this.list.find(ele => ele.id === val)
      if (obj) {
        this.$emit('changeName', obj)
      }
    },
    // 父级刷新子级的方法,重新渲染列表
    async onConsignee (cusId, id, fa) {
      this.list = await this.$getCustomerRecevie(cusId)
      if (id) {
        this.changeName(id)
      }
      if (fa) {
        const obj = this.list.find(ele => ele.isDefault === 1)
        if (obj) {
          this.changeName(obj.id)
        }
      }
    }
  }
}
</script>
